/**
 * i18n Configuration - REINFO v2
 * Languages: Spanish (es) - default, Russian (ru)
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Spanish translations (default)
const esTranslations = {
  common: {
    loading: 'Cargando...',
    error: 'Error',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    reset: 'Restablecer',
    close: 'Cerrar',
    back: 'Atrás',
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    all: 'Todos',
    none: 'Ninguno',
    share: 'Compartir',
    download: 'Descargar',
    export: 'Exportar',
    refresh: 'Actualizar',
    confirm: 'Confirmar',
    actions: 'Acciones',
    details: 'Detalles',
    info: 'Información',
    warning: 'Advertencia',
    success: 'Éxito',
    notAvailable: 'N/D',
    copy: 'Copiar',
    copied: 'Copiado',
    concessions: 'concesiones',
    show: 'Mostrar',
    hide: 'Ocultar',
    more: 'Más',
    less: 'Menos',
    new: 'Nuevo',
    add: 'Agregar',
    remove: 'Quitar',
    select: 'Seleccionar',
    selected: 'Seleccionado',
    total: 'Total',
    of: 'de',
    and: 'y',
    or: 'o',
    from: 'desde',
    to: 'hasta',
    welcome: '¡Bienvenido, {{name}}!',
    sourceType: 'Tipo de fuente',
    sourceId: 'ID de fuente',
    enrichmentType: 'Tipo de enriquecimiento',
    selectType: 'Selecciona tipo...',
    priority: 'Prioridad (1-10)',
    photos: 'Fotos',
    average: 'Promedio',
    max: 'Máx',
    showOnMap: 'Mostrar en mapa',
    minScore: 'Puntuación mín:',
    loadingLayer: 'Cargando capa...',
    topByScore: 'Top por puntuación:',
    processing: 'Procesando...',
    processed: 'procesados',
    noPhotoResults: 'Sin resultados de análisis de fotos',
    photoAnalysis: 'Análisis de fotos',
    addQuickAccess: 'Añade parcelas y concesiones a favoritos para acceso rápido',
    unavailable: 'no disponible',
    requiresRole: 'Se requiere rol de Analista o superior para exportar datos',
    exportSettings: 'Configuración de exportación',
    applyCurrentFilters: 'Aplicar filtros actuales',
    exportFilteredOnly: 'Exportar solo datos filtrados',
    includeOwnerData: 'Incluir datos del titular',
    addContactsPersonal: 'Añadir contactos y datos personales',
    includeEnrichmentData: 'Incluir datos de enriquecimiento',
    sunatOefaSatellite: 'SUNAT, OEFA, datos satelitales',
  },
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    register: 'Registrarse',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer contraseña',
    email: 'Correo electrónico',
    password: 'Contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Teléfono',
    phoneOptional: 'Teléfono (opcional)',
    rememberMe: 'Recordarme',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    role: 'Rol',
    requests: 'Solicitudes',
    loggedOut: 'Has cerrado sesión',
    loginRequired: 'Inicia sesión para agregar a favoritos',
    alreadyInFavorites: 'Ya está en favoritos',
    addedToFavorites: 'Agregado a favoritos',
    errorAdding: 'Error al agregar',
    validEmail: 'Ingresa un correo válido',
    enterEmail: 'Ingresa un correo válido',
    enterPassword: 'Ingresa la contraseña',
    minChars: 'Mínimo {{count}} caracteres',
    upperCase: 'Mínimo 1 letra mayúscula',
    oneDigit: 'Mínimo 1 dígito',
    passwordsNotMatch: 'Las contraseñas no coinciden',
    passwordHint: 'Mínimo 8 caracteres, 1 mayúscula, 1 dígito',
    sendError: 'Error al enviar',
    registerSuccess: '¡Registro exitoso! Inicia sesión.',
    registerError: 'Error de registro',
    loginError: 'Error de inicio de sesión',
    firstNamePlaceholder: 'Juan',
    lastNamePlaceholder: 'Pérez',
  },
  map: {
    layers: 'Capas',
    basemap: 'Mapa base',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    locate: 'Mi ubicación',
    fullscreen: 'Pantalla completa',
    intersect: 'Verificar punto',
    plots: 'Parcelas REINFO',
    concessions: 'Concesiones',
    forestal: 'Concesiones forestales',
    certificados: 'Certificados ambientales',
    libre: 'Áreas libres',
    userContent: 'Fotos y notas',
    osm: 'OpenStreetMap',
    satellite: 'Satélite',
    satelliteHD: 'Satélite HD',
    dark: 'Oscuro',
    orthophotos: 'Ortofoto (WebODM)',
    elevation: 'Relieve (Hillshade)',
    water: 'Cuerpos de agua (Lagunas, Ríos)',
    waterInfra: 'Infraestructura hídrica (pozos, presas)',
    roads: 'Carreteras (con zona de derecho)',
    mining: 'Catastro minero (DM, Corredor)',
    restrictions: 'Restricciones (arqueol., glaciares)',
    sernanp: 'Áreas protegidas (SERNANP)',
    comunidades: 'Comunidades nativas',
    closeLayers: 'Cerrar panel de capas',
    closeBasemap: 'Cerrar panel de mapas base',
    measure: 'Mediciones',
    favorites: 'Favoritos',
    stats: 'Estadísticas',
    environmentalIssues: 'Problemas ambientales',
    freeForClaim: 'Libre para petitorio',
  },
  plot: {
    title: 'Parcela REINFO',
    code: 'Código REINFO',
    name: 'Nombre DM',
    status: 'Estado',
    activity: 'Tipo de actividad',
    owner: 'Titular',
    location: 'Ubicación',
    coordinates: 'Coordenadas',
    concessions: 'Concesiones relacionadas',
    vigente: 'VIGENTE',
    suspendido: 'SUSPENDIDO',
    minero: 'Minero',
    department: 'Departamento',
    province: 'Provincia',
    district: 'Distrito',
    latitude: 'Latitud (lat)',
    longitude: 'Longitud (lon)',
    concessionPolygons: 'Polígonos de concesiones',
    closeCard: 'Cerrar tarjeta de parcela',
    linkCopied: 'Enlace copiado',
    copyError: 'No se pudo copiar',
    coordsCopied: 'Coordenadas copiadas',
  },
  concession: {
    title: 'Concesión Catastro',
    code: 'Código U',
    name: 'Nombre concesión',
    titular: 'Titular',
    hectareas: 'Hectáreas',
    status: 'Leyenda',
    geometry: 'Geometría',
    plots: 'Parcelas REINFO',
    vigente: 'VIGENTE',
    extinto: 'EXTINTO',
    bloqueado: 'BLOQUEADO',
    closeCard: 'Cerrar tarjeta de concesión',
    mainData: 'Datos principales',
    geometryData: 'Datos de geometría',
    type: 'Tipo',
    claimedArea: 'Área (declarada)',
    gisArea: 'Área (GIS)',
    centroidLat: 'Centroide (lat)',
    centroidLng: 'Centroide (lng)',
    terrainAnalysis: 'Análisis de terreno',
    highPrecisionAnalysis: 'Análisis de alta precisión (WebODM DSM)',
    elevationAnalysis: 'Análisis de elevación (ASTER DEM — básico)',
  },
  tabs: {
    info: 'Información',
    owner: 'Titular',
    geometry: 'Geometría',
    rurales: 'Rurales',
    comunidad: 'Comunidad',
    drones: 'Drones',
  },
  card: {
    share: 'Compartir',
    geojsonPlot: 'GeoJSON (parcela)',
    geojsonFull: 'GeoJSON (completo)',
    gpx: 'GPX',
    geometryNotLoaded: 'Geometría no cargada',
    deforestation: 'Deforestación (agricultura)',
    restrictions: 'Restricciones (restrictions)',
    waterBodies: 'Cuerpos de agua (buffer)',
    freeArea: 'Área libre',
    dsmSource: 'Fuente DSM',
    selectWebodm: 'Selecciona vuelo WebODM...',
    showElevationMap: 'Mostrar mapa de elevación',
    selectWebodmHint: 'Selecciona un vuelo WebODM para análisis preciso del terreno con DSM del drone',
    maxElevation: 'Elevación máx.',
    minElevation: 'Elevación mín.',
    avgElevation: 'Elevación prom.',
    slope: 'Pendiente',
    zones: 'zonas',
    bufferZone: 'zona de amortiguamiento',
    objects: 'objetos',
    streams: 'Arroyos',
    defaultWholeArea: 'Por defecto: toda el área',
    dataBasedOn: '* Los datos del análisis se basan en la intersección de geometrías con Monitoreo Deforestación (SERFOR), Catastro Forestal, Libre Denunciabilidad y Predios Rurales (MINAGRI, si está disponible).',
  },
  owner: {
    title: 'Titular',
    person: 'Persona natural',
    company: 'Persona jurídica',
    ruc: 'RUC',
    dni: 'DNI',
    name: 'Nombre',
    address: 'Dirección',
    phones: 'Teléfonos',
    emails: 'Correos',
    relations: 'Relaciones',
    properties: 'Propiedades',
    totalPlots: 'Total parcelas',
    totalConcessions: 'Total concesiones',
    totalHectareas: 'Total hectáreas',
    closeCard: 'Cerrar tarjeta de titular',
    identification: 'Identificación',
    personalData: 'Datos personales',
    parents: 'Padres',
    contacts: 'Contactos',
    companyInfo: 'Información de la empresa',
  },
  enrichment: {
    title: 'Enriquecimiento',
    satellite: 'Imágenes satelitales',
    parsing: 'Datos',
    analysis: 'Análisis',
    sunat: 'SUNAT',
    oefa: 'OEFA',
    sunarp: 'SUNARP',
    deforestation: 'Deforestación',
    miningActivity: 'Actividad minera',
    waterBodies: 'Cuerpos de agua',
    createJob: 'Crear tarea de enriquecimiento',
    hasData: 'Tiene',
    noData: 'No tiene',
    fillRequired: 'Completa todos los campos requeridos',
    jobCreated: 'Tarea creada',
    jobCreateError: 'Error al crear la tarea',
    jobCancelled: 'Tarea cancelada',
    jobCancelError: 'No se pudo cancelar la tarea',
    reinfoExample: 'Ej: 12959-1',
    idExample: 'Ej: 123',
  },
  favorites: {
    title: 'Favoritos',
    addToFavorites: 'Agregar a favoritos',
    removeFromFavorites: 'Quitar de favoritos',
    noFavorites: 'Sin favoritos',
    folder: 'Carpeta',
    noFolder: 'Sin carpeta',
    inFavorites: 'En favoritos',
    addError: 'Error al agregar',
    onlyReinfoFavorites: 'Solo favoritos REINFO',
    onlyCatastroFavorites: 'Solo favoritos (catastro)',
    showOnlyFavorites: 'Mostrar solo favoritos',
    removed: 'Eliminado de favoritos',
    removeError: 'Error al eliminar',
    expandFolder: 'Expandir carpeta',
    collapseFolder: 'Colapsar carpeta',
    openMenu: 'Abrir menú de favoritos',
  },
  stats: {
    title: 'Estadísticas',
    totalPlots: 'Total parcelas',
    totalConcessions: 'Total concesiones',
    totalOwners: 'Total titulares',
    totalHectareas: 'Total hectáreas',
    enriched: 'Enriquecidos',
    withPhones: 'Con teléfonos',
    withEmails: 'Con email',
    reinfoPlots: 'Parcelas REINFO',
    requestsToday: 'Solicitudes hoy',
    requestsWeek: 'Esta semana',
    requestsMonth: 'Este mes',
  },
  export: {
    title: 'Exportar datos',
    selectResource: 'Selecciona el tipo de datos',
    selectFormat: 'Selecciona el formato',
    options: 'Opciones',
    applyFilters: 'Aplicar filtros actuales',
    includeOwnerData: 'Incluir datos del titular',
    includeEnrichment: 'Incluir datos de enriquecimiento',
    ready: '¡Exportación lista!',
    processing: 'Preparando exportación...',
    additionalFormats: 'Formatos adicionales de exportación',
    customArea: 'Área personalizada',
    verifiedFormat: 'Formato WPMZ verificado',
    error: 'Error de exportación',
    csvDesc: 'Datos tabulares',
    geojsonDesc: 'Con geometría',
    excelDesc: 'Varias hojas',
    plotsResource: 'Parcelas REINFO',
    plotsDesc: 'Datos de parcelas',
    concessionsResource: 'Concesiones Catastro',
    concessionsDesc: 'Datos de concesiones',
    ownersResource: 'Titulares',
    ownersDesc: 'Datos de titulares',
  },
  reports: {
    title: 'Informes',
    ownerReport: 'Informe por titular',
    plotReport: 'Informe por parcela',
    areaReport: 'Informe por región',
    generateReport: 'Generar informe',
    exportPdf: 'Exportar a PDF',
    enterRucDni: 'Ingresa RUC o DNI',
    find: 'Buscar',
    reinfoCode: 'Código REINFO',
    concessionId: 'ID de concesión',
  },
  notes: {
    title: 'Notas',
    addNote: 'Agregar nota',
    editNote: 'Editar nota',
    noNotes: 'Sin notas aún',
    noteTitle: 'Título',
    noteContent: 'Contenido de la nota',
    category: 'Categoría',
    importance: 'Importancia',
    public: 'Pública',
    tags: 'Etiquetas',
    newNote: 'Nueva nota',
    deleteNote: 'Eliminar nota',
    deleteNoteConfirm: '¿Eliminar nota?',
    noteDeleted: 'Nota eliminada',
    noteDeleteError: 'Error al eliminar',
    noteUpdated: 'Nota actualizada',
    noteCreated: 'Nota creada',
    noteSaveError: 'Error al guardar',
    titlePlaceholder: 'Título de la nota',
    contentPlaceholder: 'Texto de la nota...',
    observation: 'Observación',
    warning: 'Advertencia',
    todo: 'Tarea',
    other: 'Otro',
  },
  photos: {
    title: 'Fotografías',
    upload: 'Subir',
    noPhotos: 'Sin fotos aún',
    selectFile: 'Selecciona un archivo',
    photoTitle: 'Título de la foto',
    description: 'Descripción',
    deletePhoto: 'Eliminar foto',
    deletePhotoConfirm: '¿Eliminar foto?',
    photoUploaded: 'Foto subida',
    photoUploadError: 'Error al subir',
    photoDeleted: 'Foto eliminada',
    photoDeleteError: 'Error al eliminar',
    closeViewer: 'Cerrar visor de fotos',
    previousPhoto: 'Foto anterior',
    nextPhoto: 'Foto siguiente',
    closeGallery: 'Cerrar galería',
    previousImage: 'Imagen anterior',
    nextImage: 'Imagen siguiente',
  },
  filters: {
    title: 'Filtros',
    status: 'Estado',
    ownerType: 'Tipo de titular',
    activityType: 'Tipo de actividad',
    department: 'Departamento',
    province: 'Provincia',
    district: 'Distrito',
    hasPhones: 'Con teléfonos',
    hasEnrichment: 'Con enriquecimiento',
    resetFilters: 'Restablecer filtros',
    additional: 'Adicionales',
    catastroFilters: 'Filtros de catastro',
    reinfoFilters: 'Filtros REINFO',
  },
  errors: {
    genericError: 'Ocurrió un error',
    notFound: 'No encontrado',
    unauthorized: 'Se requiere autorización',
    forbidden: 'Acceso denegado',
    networkError: 'Error de red',
    loadError: 'Error de carga',
    calculationError: 'Error de cálculo',
    unknownError: 'Error desconocido',
  },
  admin: {
    title: 'Administración',
    users: 'Usuarios',
    roles: 'Roles',
    audit: 'Auditoría',
    usage: 'Estadísticas de uso',
    backToMap: 'Volver al mapa',
    searchPlaceholder: 'Buscar por email o nombre...',
    userDeactivated: 'Usuario desactivado',
    deactivationError: 'Error de desactivación',
    sessionsRevoked: 'Sesiones revocadas',
    revokeError: 'Error al revocar sesiones',
    userUpdated: 'Usuario actualizado',
    updateError: 'Error de actualización',
  },
  drone: {
    title: 'Dron',
    reconnaissance: 'Reconocimiento',
    detailed: 'Detallado',
    reconFlight: 'Vuelo de reconocimiento',
    reconDescription: 'Obtención de DSM (modelo digital de superficie)',
    detailedFlight: 'Vuelo detallado',
    detailedDescription: 'Ortofoto de alta resolución (Terrain Following opcional)',
    downloadKml: 'Descargar KML para Dronelink',
    clickDownloadKml: 'Haz clic en "Descargar KML para Dronelink"',
    projectTask: 'Proyecto / Tarea',
    forTerrainFollowing: 'Para Terrain Following:',
    saveMission: 'Guardar misión',
    saveMissionToHistory: 'Guardar misión en historial',
    showOnMap: 'Mostrar en mapa',
    onMap: 'En mapa ✓',
    hideRoute: 'Ocultar ruta',
    flightRoute: 'Ruta de vuelo',
    segment: 'Segmento',
    noSavedMissions: 'Sin misiones guardadas',
    noMissionsDescription: 'Haz clic en "Guardar misión" al crear para agregar al historial',
    deleteMission: '¿Eliminar misión?',
    flights: 'Vuelos',
    shots: 'Capturas',
    time: 'Tiempo',
    terrainFollowing: 'Seguimiento de terreno para altura precisa',
    notAvailable: 'No disponible (se requiere DSM del etapa 1 o WebODM)',
    dangerTerrainAbove: '¡PELIGRO: Terreno por encima de la trayectoria!',
    selectDrone: 'Selecciona un dron...',
    starting: 'Iniciando...',
    restartAnalysis: 'Reiniciar análisis',
    startAnalysis: 'Iniciar análisis',
    analyzing: 'Analizando...',
    startV2Analysis: 'Iniciar análisis V2 (SAM)',
    startTreeInventory: 'Iniciar inventario de árboles',
  },
  geoanalysis: {
    title: 'Análisis geológico',
    newAnalysis: 'Nuevo análisis',
    queued: 'En cola',
    completed: 'Completado',
    error: 'Error',
    samStatus: 'Estado SAM',
    notLoaded: 'No cargado',
    notConfigured: 'No configurado',
    highPotential: 'Alto',
    moderateHigh: 'Moderado-Alto',
    moderate: 'Medio',
    lowPotential: 'Bajo',
    clickSelectOnMap: 'Haz clic en "Seleccionar en mapa" y marca un punto',
    clickAnalyze: 'Haz clic en "Analizar" para evaluación con IA',
    paleochannel: 'Paleocanal',
    drainage: 'Drenaje',
    laterite: 'Laterita',
    clay: 'Arcilla',
    gravel: 'Grava',
    quartz: 'Cuarzo',
    vegetationStress: 'Estrés de vegetación',
    confluence: 'Confluencia',
    steepSlope: 'Pendiente pronunciada',
    flatTerrain: 'Terreno plano',
    unknown: 'Desconocido',
    analyzed: 'Analizado',
    allScores: 'Todos',
  },
  trees: {
    title: 'Inventario de árboles',
    tree: 'Árbol',
    redBookPeru: 'Libro Rojo de Perú',
    protected: 'Protegido',
  },
  history: {
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta semana',
    older: 'Anteriores',
    empty: 'Historial de vistas vacío',
  },
  search: {
    byPhone: 'Buscar por teléfono',
    byDni: 'Buscar por DNI',
    byRuc: 'Buscar por RUC',
    byEmail: 'Buscar por email',
    byCode: 'Buscar por código REINFO',
    placeholder: 'Buscar por nombre, RUC, teléfono...',
    clear: 'Limpiar búsqueda',
  },
  empty: {
    nothingFound: 'No se encontró nada',
    tryChangingParams: 'Intenta cambiar los parámetros de búsqueda o restablece los filtros',
    noData: 'Sin datos',
    dataNotAdded: 'Los datos aún no se han agregado',
    loadError: 'Error de carga',
    loadErrorMessage: 'Ocurrió un error al cargar los datos',
    retry: 'Reintentar',
    notFoundTitle: 'No encontrado',
    notFoundMessage: 'El recurso solicitado no existe o fue eliminado',
  },
  drawing: {
    clickToClose: 'Haz clic para cerrar',
    customFlightZone: 'Zona de vuelo (personalizada)',
  },
  measure: {
    deleteAll: '¿Eliminar todas las mediciones?',
  },
  ui: {
    expandSidebar: 'Expandir panel lateral',
    collapseSidebar: 'Colapsar panel lateral',
    expandSheet: 'Expandir',
    collapseSheet: 'Colapsar',
    closeSheet: 'Cerrar',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    scrollLeft: 'Desplazar a la izquierda',
    scrollRight: 'Desplazar a la derecha',
  },
  language: {
    title: 'Idioma',
    es: 'Español',
    ru: 'Русский',
  },
};

// Russian translations
const ruTranslations = {
  common: {
    loading: 'Загрузка...',
    error: 'Ошибка',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    search: 'Поиск',
    filter: 'Фильтр',
    reset: 'Сбросить',
    close: 'Закрыть',
    back: 'Назад',
    next: 'Далее',
    yes: 'Да',
    no: 'Нет',
    all: 'Все',
    none: 'Нет',
    share: 'Поделиться',
    download: 'Скачать',
    export: 'Экспорт',
    refresh: 'Обновить',
    confirm: 'Подтвердить',
    actions: 'Действия',
    details: 'Детали',
    info: 'Информация',
    warning: 'Предупреждение',
    success: 'Успешно',
    notAvailable: 'Н/Д',
    copy: 'Копировать',
    copied: 'Скопировано',
    concessions: 'концессий',
    show: 'Показать',
    hide: 'Скрыть',
    more: 'Ещё',
    less: 'Меньше',
    new: 'Новый',
    add: 'Добавить',
    remove: 'Удалить',
    select: 'Выбрать',
    selected: 'Выбрано',
    total: 'Всего',
    of: 'из',
    and: 'и',
    or: 'или',
    from: 'от',
    to: 'до',
    welcome: 'Добро пожаловать, {{name}}!',
    sourceType: 'Тип источника',
    sourceId: 'ID источника',
    enrichmentType: 'Тип обогащения',
    selectType: 'Выберите тип...',
    priority: 'Приоритет (1-10)',
    photos: 'Фото',
    average: 'Средний',
    max: 'Макс',
    showOnMap: 'Показать на карте',
    minScore: 'Мин. оценка:',
    loadingLayer: 'Загрузка слоя...',
    topByScore: 'Топ по оценке:',
    processing: 'Обработка...',
    processed: 'обработано',
    noPhotoResults: 'Нет результатов анализа фотографий',
    photoAnalysis: 'Анализ фотографий',
    addQuickAccess: 'Добавляйте участки и концессии в избранное для быстрого доступа',
    unavailable: 'недоступен',
    requiresRole: 'Для экспорта данных требуется роль Analyst или выше',
    exportSettings: 'Настройки экспорта',
    applyCurrentFilters: 'Применить текущие фильтры',
    exportFilteredOnly: 'Экспортировать только отфильтрованные данные',
    includeOwnerData: 'Включить данные владельцев',
    addContactsPersonal: 'Добавить контакты и личные данные',
    includeEnrichmentData: 'Включить данные обогащения',
    sunatOefaSatellite: 'SUNAT, OEFA, спутниковые данные',
  },
  auth: {
    login: 'Войти',
    logout: 'Выйти',
    register: 'Регистрация',
    forgotPassword: 'Забыли пароль?',
    resetPassword: 'Сбросить пароль',
    email: 'Email',
    password: 'Пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите пароль',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phone: 'Телефон',
    phoneOptional: 'Телефон (необязательно)',
    rememberMe: 'Запомнить меня',
    noAccount: 'Нет аккаунта?',
    hasAccount: 'Уже есть аккаунт?',
    role: 'Роль',
    requests: 'Запросов',
    loggedOut: 'Вы вышли из системы',
    loginRequired: 'Войдите для добавления в избранное',
    alreadyInFavorites: 'Уже в избранном',
    addedToFavorites: 'Добавлено в избранное',
    errorAdding: 'Ошибка при добавлении',
    validEmail: 'Введите корректный email',
    enterEmail: 'Введите корректный email',
    enterPassword: 'Введите пароль',
    minChars: 'Минимум {{count}} символов',
    upperCase: 'Минимум 1 заглавная буква',
    oneDigit: 'Минимум 1 цифра',
    passwordsNotMatch: 'Пароли не совпадают',
    passwordHint: 'Минимум 8 символов, 1 заглавная буква, 1 цифра',
    sendError: 'Ошибка отправки',
    registerSuccess: 'Регистрация успешна! Войдите в систему.',
    registerError: 'Ошибка регистрации',
    loginError: 'Ошибка входа',
    firstNamePlaceholder: 'Иван',
    lastNamePlaceholder: 'Иванов',
  },
  map: {
    layers: 'Слои',
    basemap: 'Карта',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    locate: 'Моё местоположение',
    fullscreen: 'Полный экран',
    intersect: 'Проверить точку',
    plots: 'Участки REINFO',
    concessions: 'Концессии',
    forestal: 'Лесные концессии',
    certificados: 'Экологические сертификаты',
    libre: 'Свободные участки',
    userContent: 'Фото и заметки',
    osm: 'OpenStreetMap',
    satellite: 'Спутник',
    satelliteHD: 'Спутник HD',
    dark: 'Тёмная',
    orthophotos: 'Ортофото (WebODM)',
    elevation: 'Рельеф (Hillshade)',
    water: 'Водные объекты (Lagunas, Ríos)',
    waterInfra: 'Водная инфра (скважины, плотины)',
    roads: 'Дороги (с зоной отвода)',
    mining: 'Горный кадастр (DM, Corredor)',
    restrictions: 'Ограничения (археол., ледники)',
    sernanp: 'Охраняемые территории (SERNANP)',
    comunidades: 'Нативные сообщества',
    closeLayers: 'Закрыть панель слоёв',
    closeBasemap: 'Закрыть панель базовых карт',
    measure: 'Измерения',
    favorites: 'Избранное',
    stats: 'Статистика',
    environmentalIssues: 'Экологические проблемы',
    freeForClaim: 'Свободно для заявки',
  },
  plot: {
    title: 'Участок REINFO',
    code: 'Код REINFO',
    name: 'Nombre DM',
    status: 'Статус',
    activity: 'Тип активности',
    owner: 'Владелец',
    location: 'Расположение',
    coordinates: 'Координаты',
    concessions: 'Связанные концессии',
    vigente: 'VIGENTE',
    suspendido: 'SUSPENDIDO',
    minero: 'Минеро',
    department: 'Департамент',
    province: 'Провинция',
    district: 'Район',
    latitude: 'Широта (lat)',
    longitude: 'Долгота (lon)',
    concessionPolygons: 'Полигоны концессий',
    closeCard: 'Закрыть карточку участка',
    linkCopied: 'Ссылка скопирована',
    copyError: 'Не удалось скопировать',
    coordsCopied: 'Координаты скопированы',
  },
  concession: {
    title: 'Концессия Catastro',
    code: 'Código U',
    name: 'Nombre concesión',
    titular: 'Titular',
    hectareas: 'Гектары',
    status: 'Leyenda',
    geometry: 'Геометрия',
    plots: 'Участки REINFO',
    vigente: 'VIGENTE',
    extinto: 'EXTINTO',
    bloqueado: 'BLOQUEADO',
    closeCard: 'Закрыть карточку концессии',
    mainData: 'Основные данные',
    geometryData: 'Данные геометрии',
    type: 'Тип',
    claimedArea: 'Площадь (заявленная)',
    gisArea: 'Площадь (GIS)',
    centroidLat: 'Центроид (lat)',
    centroidLng: 'Центроид (lng)',
    terrainAnalysis: 'Анализ территории',
    highPrecisionAnalysis: 'Высокоточный анализ (WebODM DSM)',
    elevationAnalysis: 'Анализ высот (ASTER DEM — базовый)',
  },
  tabs: {
    info: 'Информация',
    owner: 'Собственник',
    geometry: 'Геометрия',
    rurales: 'Сельские',
    comunidad: 'Община',
    drones: 'Дроны',
  },
  card: {
    share: 'Поделиться',
    geojsonPlot: 'GeoJSON (участок)',
    geojsonFull: 'GeoJSON (полный)',
    gpx: 'GPX',
    geometryNotLoaded: 'Геометрия не загружена',
    deforestation: 'Дефорестация (агрикультура)',
    restrictions: 'Ограничения (restrictions)',
    waterBodies: 'Водные объекты (buffer)',
    freeArea: 'Свободная площадь',
    dsmSource: 'Источник DSM',
    selectWebodm: 'Выберите облёт WebODM...',
    showElevationMap: 'Показать карту высот',
    selectWebodmHint: 'Выберите облёт WebODM для высокоточного анализа рельефа на основе DSM дрона',
    maxElevation: 'Макс. высота',
    minElevation: 'Мин. высота',
    avgElevation: 'Сред. высота',
    slope: 'Уклон',
    zones: 'зон',
    bufferZone: 'зона отвода',
    objects: 'объектов',
    streams: 'Ручьи',
    defaultWholeArea: 'По умолчанию: весь участок целиком',
    dataBasedOn: '* Данные анализа основаны на пересечении геометрий с Monitoreo Deforestación (SERFOR), Catastro Forestal, Libre Denunciabilidad и Predios Rurales (MINAGRI, если доступно).',
  },
  owner: {
    title: 'Владелец',
    person: 'Физ. лицо',
    company: 'Юр. лицо',
    ruc: 'RUC',
    dni: 'DNI',
    name: 'Имя',
    address: 'Адрес',
    phones: 'Телефоны',
    emails: 'Email',
    relations: 'Связи',
    properties: 'Имущество',
    totalPlots: 'Всего участков',
    totalConcessions: 'Всего концессий',
    totalHectareas: 'Всего гектар',
    closeCard: 'Закрыть карточку владельца',
    identification: 'Идентификация',
    personalData: 'Персональные данные',
    parents: 'Родители',
    contacts: 'Контакты',
    companyInfo: 'Информация о компании',
  },
  enrichment: {
    title: 'Обогащение',
    satellite: 'Спутниковые снимки',
    parsing: 'Данные',
    analysis: 'Анализ',
    sunat: 'SUNAT',
    oefa: 'OEFA',
    sunarp: 'SUNARP',
    deforestation: 'Обезлесение',
    miningActivity: 'Горнодобыча',
    waterBodies: 'Водные объекты',
    createJob: 'Создать задачу обогащения',
    hasData: 'Есть',
    noData: 'Нет',
    fillRequired: 'Заполните все обязательные поля',
    jobCreated: 'Задача создана',
    jobCreateError: 'Ошибка создания задачи',
    jobCancelled: 'Задача отменена',
    jobCancelError: 'Не удалось отменить задачу',
    reinfoExample: 'Например: 12959-1',
    idExample: 'Например: 123',
  },
  favorites: {
    title: 'Избранное',
    addToFavorites: 'В избранное',
    removeFromFavorites: 'Удалить из избранного',
    noFavorites: 'Избранное пусто',
    folder: 'Папка',
    noFolder: 'Без папки',
    inFavorites: 'В избранном',
    addError: 'Ошибка при добавлении',
    onlyReinfoFavorites: 'Только избранное REINFO',
    onlyCatastroFavorites: 'Только избранное (кадастр)',
    showOnlyFavorites: 'Показать только избранное',
    removed: 'Удалено из избранного',
    removeError: 'Ошибка удаления',
    expandFolder: 'Развернуть папку',
    collapseFolder: 'Свернуть папку',
    openMenu: 'Открыть меню избранного',
  },
  stats: {
    title: 'Статистика',
    totalPlots: 'Всего участков',
    totalConcessions: 'Всего концессий',
    totalOwners: 'Всего владельцев',
    totalHectareas: 'Всего гектар',
    enriched: 'Обогащено',
    withPhones: 'С телефонами',
    withEmails: 'С email',
    reinfoPlots: 'Участков REINFO',
    requestsToday: 'Запросов сегодня',
    requestsWeek: 'За неделю',
    requestsMonth: 'За месяц',
  },
  export: {
    title: 'Экспорт данных',
    selectResource: 'Выберите тип данных',
    selectFormat: 'Выберите формат',
    options: 'Настройки',
    applyFilters: 'Применить текущие фильтры',
    includeOwnerData: 'Включить данные владельцев',
    includeEnrichment: 'Включить данные обогащения',
    ready: 'Экспорт готов!',
    processing: 'Подготовка экспорта...',
    additionalFormats: 'Дополнительные форматы экспорта',
    customArea: 'Кастомная область',
    verifiedFormat: 'Проверенный формат WPMZ',
    error: 'Ошибка экспорта',
    csvDesc: 'Табличные данные',
    geojsonDesc: 'С геометрией',
    excelDesc: 'Несколько листов',
    plotsResource: 'Участки REINFO',
    plotsDesc: 'Данные по участкам',
    concessionsResource: 'Концессии Catastro',
    concessionsDesc: 'Данные концессий',
    ownersResource: 'Владельцы',
    ownersDesc: 'Данные владельцев',
  },
  reports: {
    title: 'Отчёты',
    ownerReport: 'Отчёт по владельцу',
    plotReport: 'Отчёт по участку',
    areaReport: 'Отчёт по региону',
    generateReport: 'Сформировать отчёт',
    exportPdf: 'Экспорт в PDF',
    enterRucDni: 'Введите RUC или DNI',
    find: 'Найти',
    reinfoCode: 'Код REINFO',
    concessionId: 'ID концессии',
  },
  notes: {
    title: 'Заметки',
    addNote: 'Добавить заметку',
    editNote: 'Редактировать заметку',
    noNotes: 'Заметок пока нет',
    noteTitle: 'Заголовок',
    noteContent: 'Текст заметки',
    category: 'Категория',
    importance: 'Важность',
    public: 'Публичная',
    tags: 'Теги',
    newNote: 'Новая заметка',
    deleteNote: 'Удалить заметку',
    deleteNoteConfirm: 'Удалить заметку?',
    noteDeleted: 'Заметка удалена',
    noteDeleteError: 'Ошибка удаления',
    noteUpdated: 'Заметка обновлена',
    noteCreated: 'Заметка создана',
    noteSaveError: 'Ошибка сохранения',
    titlePlaceholder: 'Заголовок заметки',
    contentPlaceholder: 'Текст заметки...',
    observation: 'Наблюдение',
    warning: 'Предупреждение',
    todo: 'Задача',
    other: 'Другое',
  },
  photos: {
    title: 'Фотографии',
    upload: 'Загрузить',
    noPhotos: 'Фотографий пока нет',
    selectFile: 'Выберите файл',
    photoTitle: 'Название фотографии',
    description: 'Описание',
    deletePhoto: 'Удалить фото',
    deletePhotoConfirm: 'Удалить фото?',
    photoUploaded: 'Фото загружено',
    photoUploadError: 'Ошибка загрузки',
    photoDeleted: 'Фото удалено',
    photoDeleteError: 'Ошибка удаления',
    closeViewer: 'Закрыть просмотр фото',
    previousPhoto: 'Предыдущее фото',
    nextPhoto: 'Следующее фото',
    closeGallery: 'Закрыть галерею',
    previousImage: 'Предыдущий снимок',
    nextImage: 'Следующий снимок',
  },
  filters: {
    title: 'Фильтры',
    status: 'Статус',
    ownerType: 'Тип владельца',
    activityType: 'Тип активности',
    department: 'Департамент',
    province: 'Провинция',
    district: 'Район',
    hasPhones: 'С телефонами',
    hasEnrichment: 'С обогащением',
    resetFilters: 'Сбросить фильтры',
    additional: 'Дополнительно',
    catastroFilters: 'Фильтры кадастра',
    reinfoFilters: 'Фильтры REINFO',
  },
  errors: {
    genericError: 'Произошла ошибка',
    notFound: 'Не найдено',
    unauthorized: 'Требуется авторизация',
    forbidden: 'Доступ запрещён',
    networkError: 'Ошибка сети',
    loadError: 'Ошибка загрузки',
    calculationError: 'Ошибка расчёта',
    unknownError: 'Неизвестная ошибка',
  },
  admin: {
    title: 'Администрирование',
    users: 'Пользователи',
    roles: 'Роли',
    audit: 'Аудит',
    usage: 'Статистика использования',
    backToMap: 'Вернуться на карту',
    searchPlaceholder: 'Поиск по email или имени...',
    userDeactivated: 'Пользователь деактивирован',
    deactivationError: 'Ошибка деактивации',
    sessionsRevoked: 'Сессии отозваны',
    revokeError: 'Ошибка отзыва сессий',
    userUpdated: 'Пользователь обновлён',
    updateError: 'Ошибка обновления',
  },
  drone: {
    title: 'Дрон',
    reconnaissance: 'Разведка',
    detailed: 'Детальный',
    reconFlight: 'Разведочный облёт',
    reconDescription: 'Получение DSM (цифровой модели поверхности)',
    detailedFlight: 'Детальный облёт',
    detailedDescription: 'Высокодетальное ортофото (Terrain Following опционально)',
    downloadKml: 'Скачать KML для Dronelink',
    clickDownloadKml: 'Нажмите "Скачать KML для Dronelink"',
    projectTask: 'Проект / Задача',
    forTerrainFollowing: 'Для Terrain Following:',
    saveMission: 'Сохранить миссию',
    saveMissionToHistory: 'Сохранить миссию в историю',
    showOnMap: 'Показать на карте',
    onMap: 'На карте ✓',
    hideRoute: 'Скрыть маршрут',
    flightRoute: 'Маршрут облёта',
    segment: 'Сегмент',
    noSavedMissions: 'Нет сохранённых миссий',
    noMissionsDescription: 'Нажмите "Сохранить миссию" при создании для добавления в историю',
    deleteMission: 'Удалить миссию?',
    flights: 'Полётов',
    shots: 'Снимков',
    time: 'Время',
    terrainFollowing: 'Следование рельефу для точной высоты',
    notAvailable: 'Недоступно (требуется DSM из этапа 1 или WebODM)',
    dangerTerrainAbove: 'ОПАСНО: Рельеф выше траектории!',
    selectDrone: 'Выберите дрон...',
    starting: 'Запуск...',
    restartAnalysis: 'Перезапустить анализ',
    startAnalysis: 'Запустить анализ',
    analyzing: 'Анализ...',
    startV2Analysis: 'Запустить V2 анализ (SAM)',
    startTreeInventory: 'Начать инвентаризацию деревьев',
  },
  geoanalysis: {
    title: 'Геоанализ',
    newAnalysis: 'Новый анализ',
    queued: 'В очереди',
    completed: 'Завершён',
    error: 'Ошибка',
    samStatus: 'Статус SAM',
    notLoaded: 'Не загружен',
    notConfigured: 'Не настроен',
    highPotential: 'Высокий',
    moderateHigh: 'Выше среднего',
    moderate: 'Средний',
    lowPotential: 'Низкий',
    clickSelectOnMap: 'Кликните "Выбрать на карте" и укажите точку',
    clickAnalyze: 'Нажмите "Анализировать" для AI-оценки',
    paleochannel: 'Палеоканал',
    drainage: 'Дренаж',
    laterite: 'Латерит',
    clay: 'Глина',
    gravel: 'Гравий',
    quartz: 'Кварц',
    vegetationStress: 'Стресс растительности',
    confluence: 'Слияние рек',
    steepSlope: 'Крутой склон',
    flatTerrain: 'Плоский рельеф',
    unknown: 'Неизвестно',
    analyzed: 'Анализ',
    allScores: 'Все',
  },
  trees: {
    title: 'Инвентаризация деревьев',
    tree: 'Дерево',
    redBookPeru: 'Красная книга Перу',
    protected: 'Охраняемый',
  },
  history: {
    today: 'Сегодня',
    yesterday: 'Вчера',
    thisWeek: 'На этой неделе',
    older: 'Ранее',
    empty: 'История просмотров пуста',
  },
  search: {
    byPhone: 'Поиск по телефону',
    byDni: 'Поиск по DNI',
    byRuc: 'Поиск по RUC',
    byEmail: 'Поиск по email',
    byCode: 'Поиск по коду REINFO',
    placeholder: 'Поиск по имени, RUC, телефону...',
    clear: 'Очистить поиск',
  },
  empty: {
    nothingFound: 'Ничего не найдено',
    tryChangingParams: 'Попробуйте изменить параметры поиска или сбросить фильтры',
    noData: 'Нет данных',
    dataNotAdded: 'Данные пока не добавлены',
    loadError: 'Ошибка загрузки',
    loadErrorMessage: 'Произошла ошибка при загрузке данных',
    retry: 'Повторить',
    notFoundTitle: 'Не найдено',
    notFoundMessage: 'Запрашиваемый ресурс не существует или был удалён',
  },
  drawing: {
    clickToClose: 'Кликни чтобы замкнуть',
    customFlightZone: 'Зона полёта (кастомная)',
  },
  measure: {
    deleteAll: 'Удалить все измерения?',
  },
  ui: {
    expandSidebar: 'Развернуть боковую панель',
    collapseSidebar: 'Свернуть боковую панель',
    expandSheet: 'Развернуть',
    collapseSheet: 'Свернуть',
    closeSheet: 'Закрыть',
    openMenu: 'Открыть меню',
    closeMenu: 'Закрыть меню',
    scrollLeft: 'Прокрутить влево',
    scrollRight: 'Прокрутить вправо',
  },
  language: {
    title: 'Язык',
    es: 'Español',
    ru: 'Русский',
  },
};

// Detect language based on user agent
function detectLanguage(): string {
  if (typeof navigator === 'undefined') return 'es';
  
  // Check localStorage first
  const savedLang = localStorage.getItem('language');
  if (savedLang && ['es', 'ru'].includes(savedLang)) {
    return savedLang;
  }
  
  // Check user agent for Russian
  const userAgent = navigator.userAgent.toLowerCase();
  const languages = navigator.languages || [navigator.language];
  
  // Check if any language preference is Russian
  const hasRussian = languages.some(lang => 
    lang.toLowerCase().startsWith('ru')
  );
  
  // Check for Russian in user agent (some browsers include locale)
  const ruInAgent = userAgent.includes('ru-ru') || userAgent.includes('ru_ru');
  
  if (hasRussian || ruInAgent) {
    return 'ru';
  }
  
  return 'es'; // Default to Spanish
}

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: esTranslations },
      ru: { translation: ruTranslations },
    },
    lng: detectLanguage(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

// Save language preference
export function changeLanguage(lang: string) {
  localStorage.setItem('language', lang);
  i18n.changeLanguage(lang);
}

export default i18n;
